export enum SchedulerMode {
  Now = 0,
  Scheduled = 1,
}
